export default {
    sampleDataProgress: 0,
    sampleDataTotal: 7,
    sampleDataStarted: false,
    sampleDataSuccess: false,
    sampleDataCtaDismissed: false,
    addSampleDataErrorCount: 0,
};
